import React from 'react'
import * as R from 'ramda'
import { ThemeProvider } from 'styled-components'
import { inputColors } from 'sidecar-design-library'

import { Wrap, Icon, ReactSelect, ReactCreatable, Label } from './styles'
import enhance from './enhance'
import './react-select-customized.css'

const InputSelect = ({
  input: { onChange, value, ...restInput },
  meta: { visited, touched, error },
  showLabel,
  handleChange,
  placeholder,
  readOnly = false,
  label,
  className,
  creatable,
  dropDown = true,
  redactFilterData = false,
  ...rest
}) => (
  <ThemeProvider
    theme={
      touched && error
        ? inputColors.inputSelectError
        : inputColors.inputSelectDefault
    }
  >
    <Wrap
      className={className}
      data-testid={
        rest['data-testid'] ? rest['data-testid'] + 'InputSelect' : ''
      }
      // including count for these so that QA can write better automation
      data-count={R.pathOr(0, ['options', 'length'], rest)}
      data-heap-redact-text={redactFilterData}
    >
      {label && (
        <Label
          visited={showLabel || visited || value}
          className="label"
          fieldDisabled={readOnly}
        >
          {label}
        </Label>
      )}

      {creatable ? (
        <ReactCreatable
          className={(showLabel || visited || value) && 'visited'}
          onChange={handleChange}
          placeholder={placeholder}
          arrowRenderer={() => <Icon name="dropdown" />}
          value={value.toJS ? value.toJS() : value}
          clearable={false}
          searchable={false}
          isValidNewOption={() => false}
          dropDown={dropDown}
          {...restInput}
          onBlur={() => {}} //Keep onBlur here to override redux-form but allow for custom onBlur
          {...rest}
        />
      ) : (
        <ReactSelect
          className={(showLabel || visited || value) && 'visited'}
          onChange={handleChange}
          placeholder={placeholder}
          arrowRenderer={() => <Icon name="dropdown" />}
          value={value.toJS ? value.toJS() : value}
          clearable={false}
          searchable={false}
          isValidNewOption={() => false}
          dropDown={dropDown}
          {...restInput}
          onBlur={() => {}} //Keep onBlur here to override redux-form but allow for custom onBlur
          {...rest}
        />
      )}
    </Wrap>
  </ThemeProvider>
)

export default enhance(InputSelect)
